import { createRoute } from '@/utils/routing'

export const CUSTOM_REQUEST_LIST_ROUTE = 'custom-requests'
export const CUSTOM_REQUEST_VIEW_ROUTE = 'custom-requests-requestId'

export function createCustomRequestListRoute (options = {}) {
  return createRoute(CUSTOM_REQUEST_LIST_ROUTE, options)
}

export function createCustomRequestViewRoute (requestId, options = {}) {
  if (requestId != null) {
    return createRoute(CUSTOM_REQUEST_VIEW_ROUTE, {
      params: { ...options.params, requestId },
      query: options.query
    })
  }
}
